import { render } from "./AddTheme.vue?vue&type=template&id=2cb469b2&ts=true"
import script from "./AddTheme.vue?vue&type=script&lang=ts"
export * from "./AddTheme.vue?vue&type=script&lang=ts"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__